// Enhanced image cluster system using emoji as lightweight images
// 10-15 small animated images per service

import React from 'react';

// Small image-style elements for each service category
export const SERVICE_IMAGE_CLUSTERS = {
  // COMPLIANCE SERVICES  
  "accounting": [
    { content: '📊', size: 50, position: { top: '5%', left: '15%' }, delay: 0, animation: 'animate-float' },
    { content: '💰', size: 45, position: { top: '15%', right: '10%' }, delay: 0.3, animation: 'animate-bounce-custom' },
    { content: '📈', size: 40, position: { top: '30%', left: '25%' }, delay: 0.6, animation: 'animate-sway' },
    { content: '💵', size: 38, position: { top: '45%', right: '20%' }, delay: 0.9, animation: 'animate-pulse-custom' },
    { content: '🧮', size: 48, position: { top: '25%', left: '45%' }, delay: 1.2, animation: 'animate-float-rotate' },
    { content: '📋', size: 42, position: { bottom: '30%', right: '15%' }, delay: 1.5, animation: 'animate-float' },
    { content: '💼', size: 44, position: { bottom: '15%', left: '20%' }, delay: 1.8, animation: 'animate-bounce-custom' },
    { content: '📑', size: 36, position: { top: '60%', right: '25%' }, delay: 2.1, animation: 'animate-sway' },
    { content: '🔢', size: 40, position: { bottom: '40%', left: '35%' }, delay: 2.4, animation: 'animate-pulse-custom' },
    { content: '💳', size: 38, position: { top: '70%', right: '35%' }, delay: 2.7, animation: 'animate-float-rotate' },
  ],
  
  "gst-filing": [
    { content: '📝', size: 48, position: { top: '10%', left: '20%' }, delay: 0, animation: 'animate-float' },
    { content: '✅', size: 42, position: { top: '25%', right: '15%' }, delay: 0.4, animation: 'animate-pulse-custom' },
    { content: '📄', size: 45, position: { top: '40%', left: '15%' }, delay: 0.8, animation: 'animate-bounce-custom' },
    { content: '🛡️', size: 40, position: { top: '55%', right: '20%' }, delay: 1.2, animation: 'animate-sway' },
    { content: '📊', size: 38, position: { bottom: '25%', left: '25%' }, delay: 1.6, animation: 'animate-float-rotate' },
    { content: '💼', size: 44, position: { top: '70%', right: '30%' }, delay: 2.0, animation: 'animate-float' },
    { content: '🔒', size: 36, position: { bottom: '35%', right: '10%' }, delay: 2.4, animation: 'animate-bounce-custom' },
    { content: '📋', size: 40, position: { top: '35%', left: '40%' }, delay: 2.8, animation: 'animate-pulse-custom' },
  ],
  
  // IT SERVICES
  "cybersecurity": [
    { content: '🛡️', size: 52, position: { top: '8%', left: '18%' }, delay: 0, animation: 'animate-float-rotate' },
    { content: '🔒', size: 46, position: { top: '22%', right: '12%' }, delay: 0.4, animation: 'animate-pulse-custom' },
    { content: '🔐', size: 44, position: { top: '38%', left: '20%' }, delay: 0.8, animation: 'animate-bounce-custom' },
    { content: '🖥️', size: 48, position: { top: '52%', right: '18%' }, delay: 1.2, animation: 'animate-sway' },
    { content: '🌐', size: 40, position: { bottom: '28%', left: '25%' }, delay: 1.6, animation: 'animate-float' },
    { content: '⚡', size: 38, position: { top: '68%', right: '25%' }, delay: 2.0, animation: 'animate-pulse-custom' },
    { content: '🔑', size: 42, position: { bottom: '38%', right: '8%' }, delay: 2.4, animation: 'animate-float-rotate' },
    { content: '💾', size: 36, position: { top: '45%', left: '42%' }, delay: 2.8, animation: 'animate-bounce-custom' },
    { content: '🚨', size: 40, position: { bottom: '48%', right: '32%' }, delay: 3.2, animation: 'animate-sway' },
  ],
  
  "cloud-computing": [
    { content: '☁️', size: 54, position: { top: '12%', left: '22%' }, delay: 0, animation: 'animate-float' },
    { content: '💽', size: 44, position: { top: '28%', right: '15%' }, delay: 0.5, animation: 'animate-bounce-custom' },
    { content: '🖥️', size: 46, position: { top: '42%', left: '18%' }, delay: 1.0, animation: 'animate-sway' },
    { content: '📡', size: 40, position: { top: '58%', right: '22%' }, delay: 1.5, animation: 'animate-pulse-custom' },
    { content: '💾', size: 42, position: { bottom: '22%', left: '28%' }, delay: 2.0, animation: 'animate-float-rotate' },
    { content: '🌐', size: 38, position: { top: '72%', right: '28%' }, delay: 2.5, animation: 'animate-float' },
    { content: '⚙️', size: 36, position: { bottom: '32%', right: '10%' }, delay: 3.0, animation: 'animate-bounce-custom' },
    { content: '🔄', size: 40, position: { top: '38%', left: '45%' }, delay: 3.5, animation: 'animate-pulse-custom' },
  ],
  
  // SUPPLIES
  "office-supplies": [
    { content: '📦', size: 48, position: { top: '10%', left: '20%' }, delay: 0, animation: 'animate-bounce-custom' },
    { content: '📎', size: 36, position: { top: '25%', right: '15%' }, delay: 0.4, animation: 'animate-float' },
    { content: '✏️', size: 40, position: { top: '40%', left: '15%' }, delay: 0.8, animation: 'animate-sway' },
    { content: '📌', size: 34, position: { top: '55%', right: '20%' }, delay: 1.2, animation: 'animate-pulse-custom' },
    { content: '📋', size: 42, position: { bottom: '25%', left: '25%' }, delay: 1.6, animation: 'animate-float-rotate' },
    { content: '🖊️', size: 38, position: { top: '70%', right: '25%' }, delay: 2.0, animation: 'animate-float' },
    { content: '📏', size: 36, position: { bottom: '35%', right: '10%' }, delay: 2.4, animation: 'animate-bounce-custom' },
    { content: '💼', size: 44, position: { top: '35%', left: '40%' }, delay: 2.8, animation: 'animate-sway' },
    { content: '📁', size: 40, position: { bottom: '45%', right: '30%' }, delay: 3.2, animation: 'animate-pulse-custom' },
  ],
  
  "kitchen-pantry": [
    { content: '☕', size: 50, position: { top: '12%', left: '22%' }, delay: 0, animation: 'animate-float-rotate' },
    { content: '🥤', size: 44, position: { top: '28%', right: '15%' }, delay: 0.5, animation: 'animate-bounce-custom' },
    { content: '🍪', size: 42, position: { top: '44%', left: '18%' }, delay: 1.0, animation: 'animate-pulse-custom' },
    { content: '🥨', size: 40, position: { top: '60%', right: '20%' }, delay: 1.5, animation: 'animate-sway' },
    { content: '🧃', size: 38, position: { bottom: '20%', left: '25%' }, delay: 2.0, animation: 'animate-float' },
    { content: '🍵', size: 42, position: { top: '75%', right: '28%' }, delay: 2.5, animation: 'animate-float-rotate' },
    { content: '🥐', size: 36, position: { bottom: '32%', right: '10%' }, delay: 3.0, animation: 'animate-bounce-custom' },
    { content: '🥤', size: 40, position: { top: '36%', left: '42%' }, delay: 3.5, animation: 'animate-pulse-custom' },
  ],
  
  "fresh-fruits": [
    { content: '🍎', size: 50, position: { top: '15%', left: '20%' }, delay: 0, animation: 'animate-bounce-custom' },
    { content: '🍊', size: 48, position: { top: '30%', right: '15%' }, delay: 0.5, animation: 'animate-float' },
    { content: '🍌', size: 46, position: { top: '45%', left: '15%' }, delay: 1.0, animation: 'animate-sway' },
    { content: '🍇', size: 44, position: { top: '60%', right: '20%' }, delay: 1.5, animation: 'animate-pulse-custom' },
    { content: '🍓', size: 42, position: { bottom: '22%', left: '25%' }, delay: 2.0, animation: 'animate-float-rotate' },
    { content: '🥝', size: 40, position: { top: '75%', right: '25%' }, delay: 2.5, animation: 'animate-float' },
    { content: '🍉', size: 38, position: { bottom: '35%', right: '10%' }, delay: 3.0, animation: 'animate-bounce-custom' },
  ],
  
  // MANPOWER
  "permanent-staffing": [
    { content: '👥', size: 50, position: { top: '10%', left: '20%' }, delay: 0, animation: 'animate-float' },
    { content: '💼', size: 44, position: { top: '25%', right: '15%' }, delay: 0.4, animation: 'animate-bounce-custom' },
    { content: '🤝', size: 46, position: { top: '40%', left: '15%' }, delay: 0.8, animation: 'animate-pulse-custom' },
    { content: '📋', size: 40, position: { top: '55%', right: '20%' }, delay: 1.2, animation: 'animate-sway' },
    { content: '✅', size: 42, position: { bottom: '25%', left: '25%' }, delay: 1.6, animation: 'animate-float-rotate' },
    { content: '🎯', size: 38, position: { top: '70%', right: '25%' }, delay: 2.0, animation: 'animate-float' },
    { content: '👔', size: 36, position: { bottom: '35%', right: '10%' }, delay: 2.4, animation: 'animate-bounce-custom' },
    { content: '🏆', size: 40, position: { top: '35%', left: '40%' }, delay: 2.8, animation: 'animate-pulse-custom' },
  ],
  
  "executive-search": [
    { content: '🎯', size: 52, position: { top: '15%', left: '22%' }, delay: 0, animation: 'animate-float-rotate' },
    { content: '👔', size: 46, position: { top: '32%', right: '15%' }, delay: 0.5, animation: 'animate-pulse-custom' },
    { content: '🏆', size: 48, position: { top: '48%', left: '18%' }, delay: 1.0, animation: 'animate-bounce-custom' },
    { content: '💼', size: 44, position: { bottom: '28%', right: '20%' }, delay: 1.5, animation: 'animate-sway' },
    { content: '📊', size: 40, position: { top: '65%', left: '28%' }, delay: 2.0, animation: 'animate-float' },
    { content: '🤵', size: 38, position: { bottom: '38%', right: '28%' }, delay: 2.5, animation: 'animate-pulse-custom' },
  ],
};

// Default fallback
const DEFAULT_IMAGES = [
  { content: '📦', size: 48, position: { top: '15%', left: '20%' }, delay: 0, animation: 'animate-float' },
  { content: '💼', size: 44, position: { top: '40%', right: '15%' }, delay: 0.5, animation: 'animate-bounce-custom' },
  { content: '📊', size: 42, position: { bottom: '25%', left: '25%' }, delay: 1.0, animation: 'animate-pulse-custom' },
];

export const ImageCluster = ({ slug, accent }) => {
  const imageConfig = SERVICE_IMAGE_CLUSTERS[slug] || DEFAULT_IMAGES;
  
  return (
    <div className="relative w-full h-[400px]">
      {imageConfig.map((config, index) => {
        const { content, size, position, delay, animation } = config;
        
        return (
          <div
            key={index}
            className={`absolute ${animation}`}
            style={{
              ...position,
              animationDelay: `${delay}s`,
            }}
          >
            <div 
              className="relative"
              style={{
                fontSize: `${size}px`,
                filter: `drop-shadow(0 4px 12px ${accent}20)`,
              }}
            >
              <span className="block hover:scale-110 transition-transform duration-300">
                {content}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
